import React from "react";
import { IoHome, IoMail, IoCall } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import {
  FaFacebookSquare,
  FaTwitterSquare,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import footerImage from "../assets/images/footer2.avif";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="relative bg-primary-100 pt-8">
      {/* <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${footerImage})`, opacity: 0.15 }}
      /> */}
      <div className="relative z-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-wrap mb-6 text-left text-text">
            <div className="w-full lg:w-1/2 mb-8 lg:mb-0 pr-10">
              <div className="contact-left">
                <h3 className="text-2xl font-medium mb-5 font-serif text-primary">
                  {t("contact.footer.companyName")}
                </h3>
                <p className="mb-4 text-gray-600">
                  {t("contact.footer.description")}
                </p>
                <p className="mb-4 text-gray-600">{t("contact.footer.cta")}</p>

                <div className="flex justify-left space-x-4 text-2xl">
                  <a
                    href="https://www.facebook.com/munishnutrition"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-primary"
                  >
                    <FaFacebookSquare className="text-2xl" />
                  </a>
                  <a
                    href="https://www.twitter.com/munishnutrition"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-primary"
                  >
                    <FaTwitterSquare className="text-2xl" />
                  </a>
                  <a
                    href="https://www.instagram.com/munishnutrition"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-primary"
                  >
                    <FaInstagram className="text-2xl" />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/munishnutrition"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-primary"
                  >
                    <FaLinkedin className="text-2xl" />
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/4 mb-8 lg:mb-0">
              <div className="navigation">
                <h3 className="text-2xl font-medium mb-5 font-serif text-primary">
                  {t("contact.footer.navigation.title")}
                </h3>
                <ul className="space-y-2">
                  <li>
                    <a href="#" className="text-gray-600 hover:text-primary">
                      {t("contact.footer.navigation.links.home")}
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-600 hover:text-primary">
                      {t("contact.footer.navigation.links.aboutUs")}
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-600 hover:text-primary">
                      {t("contact.footer.navigation.links.services")}
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-gray-600 hover:text-primary">
                      {t("contact.footer.navigation.links.contact")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="w-full lg:w-1/4 mb-8 lg:mb-0">
              <div className="contact-headquarters">
                <h3 className="text-2xl font-medium mb-5 font-serif text-primary">
                  {t("contact.footer.headquarters.title")}
                </h3>
                <div className="flex items-center justify-start mb-4">
                  <IoHome className="mt-1 mr-4 text-primary" />
                  <address className="not-italic text-gray-600">
                    {t("contact.footer.headquarters.address.line1")}
                    <br />
                    {t("contact.footer.headquarters.address.line2")}
                    <br />
                    {t("contact.footer.headquarters.address.city")}
                  </address>
                </div>
                <div className="flex items-center justify-start mb-4 text-gray-600">
                  <IoCall className="mr-4 mt-1 text-primary" />
                  <p>{t("contact.footer.headquarters.phone")}</p>
                </div>
                <div className="flex items-center justify-start text-gray-600">
                  <IoMail className="mr-4 mt-1 text-primary" />
                  <p>{t("contact.footer.headquarters.email")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-300 py-6 text-center text-gray-600">
            <p className="text-primary mb-4">
              Copyright &copy; 2024 Munish Nutrition. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
